import type { AppIconProps } from '../Icons.types';

export const AppMenuIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  return (
    <svg
      {...rest}
      className={className}
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.93294 1.43294H15.5996M8.93294 4.76628H13.0996M8.93294 9.76628H15.5996M8.93294 13.0996H13.0996M0.599609 1.43294C0.599609 1.21193 0.687407 0.999967 0.843687 0.843687C0.999967 0.687407 1.21193 0.599609 1.43294 0.599609H4.76628C4.98729 0.599609 5.19925 0.687407 5.35553 0.843687C5.51181 0.999967 5.59961 1.21193 5.59961 1.43294V4.76628C5.59961 4.98729 5.51181 5.19925 5.35553 5.35553C5.19925 5.51181 4.98729 5.59961 4.76628 5.59961H1.43294C1.21193 5.59961 0.999967 5.51181 0.843687 5.35553C0.687407 5.19925 0.599609 4.98729 0.599609 4.76628V1.43294ZM0.599609 9.76628C0.599609 9.54526 0.687407 9.3333 0.843687 9.17702C0.999967 9.02074 1.21193 8.93294 1.43294 8.93294H4.76628C4.98729 8.93294 5.19925 9.02074 5.35553 9.17702C5.51181 9.3333 5.59961 9.54526 5.59961 9.76628V13.0996C5.59961 13.3206 5.51181 13.5326 5.35553 13.6889C5.19925 13.8451 4.98729 13.9329 4.76628 13.9329H1.43294C1.21193 13.9329 0.999967 13.8451 0.843687 13.6889C0.687407 13.5326 0.599609 13.3206 0.599609 13.0996V9.76628Z"
        stroke="#5D708C"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
